import { base_colorAction, base_colorContentBorder } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_semibold,
  font_size_xs,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const anchor = css`
  position: relative;
  display: inline-flex;
`

/**
 * The menu floats ABOVE its trigger, right-aligned to it.
 *
 * Upwards because these rows sit low in a long list and a downward menu on the
 * last row would open past the bottom of the page; right-aligned because the
 * trigger is the last control in a right-aligned action group, so a
 * left-aligned menu would hang off the card edge.
 */
export const menu = css`
  position: absolute;
  right: 0;
  bottom: calc(100% + ${spacing(2)});
  z-index: 80;
`

/**
 * The format chip on each option — "PDF", "XLS", "CSV".
 *
 * Decorative: it repeats the option's own text label, which is why it is
 * `aria-hidden` at the render site. Fixed dimensions so the three chips line up
 * as a column regardless of their glyph widths.
 *
 * Two deliberate deviations from the design render, both forced by the token
 * set: the prototype draws 9px at weight 700, and this repo has no 9px size
 * token and no bold face (`font_family_weight_bold` is commented out in
 * `ext-ui/style/typography` as absent from the codebase). `font_size_xs` (10px)
 * and semibold are the nearest available, and both err toward legibility.
 * Every other value — 32×20, the 6px radius, the 1px border, the action-coloured
 * text — matches the render exactly.
 */
export const formatChip = css`
  width: 32px;
  height: 20px;
  border-radius: 6px;
  border: 1px solid ${base_colorContentBorder};
  color: ${base_colorAction};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: ${font_size_xs};
  font-family: ${font_family_weight_semibold};
`
